import { render, staticRenderFns } from "./ChangelogCard.vue?vue&type=template&id=c9d4e2f8&scoped=true"
import script from "./ChangelogCard.vue?vue&type=script&lang=ts"
export * from "./ChangelogCard.vue?vue&type=script&lang=ts"
import style0 from "./ChangelogCard.vue?vue&type=style&index=0&id=c9d4e2f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9d4e2f8",
  null
  
)

export default component.exports